/**
 * The words of the firm the console acts in, from its kind
 * (`organizations.governance`): Noctant's own org speaks simulations, a firm
 * its challenges. One source, challenge-text's `orgWords`, the same table the
 * trader app reads; its small wasm loads the first time words are read. They
 * are nouns only: a run's money words follow the run (`feeWords`,
 * `payoutWords`), and the template builder words its own.
 */

import { createSignal } from "solid-js";
import { orgWords, ruleTextLoaded, type OrgWords } from "@noctant/challenge-builder";

import type { MeView } from "./api";
import { firmGovernance } from "./firm";
import { loadRuleText } from "./ruleText";

const [arrived, setArrived] = createSignal(false);

/** The acting firm's words: a firm's staff's own firm, or the firm platform
 *  staff chose; none before it is known or before the words load. */
export function firmWords(admin: MeView | undefined): OrgWords | null {
  if (!admin) return null;
  const governance = admin.org_id ? (admin.org_governance ?? null) : firmGovernance();
  if (governance === null) return null;
  if (!arrived() || !ruleTextLoaded()) {
    void loadRuleText().then(() => setArrived(true));
    return null;
  }
  return orgWords(governance);
}
